/**
 * Public runtime config. Everything here ships in the client bundle — no secrets.
 * The admin's refresh token is NEVER in JS: it lives in an httpOnly cookie set by
 * the backend (see docs/BACKEND-INTEGRATION.md § Admin session).
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing ${name}. Copy .env.example to .env and fill it in before running the admin.`,
    );
  }
  return value;
}

export const API_URL = required("VITE_API_URL", import.meta.env.VITE_API_URL).replace(/\/$/, "");
export const TENANT_ID = required("VITE_TENANT_ID", import.meta.env.VITE_TENANT_ID);
